import React from 'react';
import ContractActivationDialog from './ContractActivationDialog';
import ContractActivationDialogService from '../services/ContractActivationDialogService';
import { observer } from 'mobx-react';

const ContractActivationDialogContainer = () => (
  <ContractActivationDialog
    isOpen={ContractActivationDialogService.isOpen}
    onChange={ContractActivationDialogService.form.setValue}
    onCancel={ContractActivationDialogService.close}
    onConfirm={ContractActivationDialogService.handleActivate}
    values={ContractActivationDialogService.form.getValues()}
    errors={ContractActivationDialogService.form.errors}
  />
);

export default observer(ContractActivationDialogContainer);
